module.exports = __webpack_public_path__ + "img/task.edd40022.png";